// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"d4e97608","839":"3af83fcc"}[chunkId] + ".chunk.css";
};